import React from 'react';

import { Grid } from '@gogame/components';
import { SidePageV2, withForm } from '@gogame/form';

import { ExtraProvider } from 'scenes/SmartRules/SmartRuleForm/ExtraContext';
import { General } from 'scenes/SmartRules/SmartRuleForm/General';

import { AdvertisingPopulations } from '../AdvertisingPopulations';

export const PopulationCustomizeForm = withForm({
  enableReinitialize: true,
})(({ onClose, onExited, onChange, open }) => {
  return (
    <ExtraProvider>
      <SidePageV2
        open={open}
        onClose={onClose}
        onExited={onExited}
        onChange={onChange}
        size={'md'}
      >
        <SidePageV2.Title title={'Customize Population'} />
        <SidePageV2.Content>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <General xs={12} withName={false} />
            </Grid>
            <Grid item xs={12} pb={2}>
              <AdvertisingPopulations xs={12} />
            </Grid>
          </Grid>
        </SidePageV2.Content>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
      </SidePageV2>
    </ExtraProvider>
  );
});
